import { createSlice } from '@reduxjs/toolkit';

export const ProfileCompletionSlice = createSlice({
  name: 'ProfileCompletion',
  initialState: {
    ProfileCompletion: {},
    loading: false,
    error: null,
  },
  reducers: {
    PROFILE_COMPLETION_REQUEST: (state) => {
      state.loading = true;
      state.error = null;
    },
    PROFILE_COMPLETION_SUCCESS: (state, action) => {
      state.loading = false;
      state.error = null;
      state.ProfileCompletion = action.payload;
    },
    PROFILE_COMPLETION_FAIL: (state, action) => {
      state.loading = false;
      state.error = action.payload ?? 'Failed to load profile completion';
      state.ProfileCompletion = {};
    },
  },
});

export const {
  PROFILE_COMPLETION_REQUEST,
  PROFILE_COMPLETION_SUCCESS,
  PROFILE_COMPLETION_FAIL,
} = ProfileCompletionSlice.actions;

export default ProfileCompletionSlice.reducer;


